import React from 'react'
import Headroom from 'react-headroom'
import Link from '../../components/base/link'
import { fonts, colors } from '../../themes'
import Grid from 'material-ui/Grid';
import presets from 'lib/presets'
import FolderSpecial from 'material-ui-icons/FolderSpecial'
import SimpleLineIcon from 'react-simple-line-icons'
const FaCalendar = require('react-icons/lib/fa/calendar')

const styles = {
  avatar: {
    backgroundColor: colors.green,
    color: colors.white,
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    borderRadius: '100%',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    justifyContent: 'space-around',
    width: '100%',
    maxWidth: 800,
    padding: 20,
    [presets.Tablet]: {
      flexDirection: 'row',
    },
  },
  iconHolder: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: 80,
    height: 80,
    backgroundColor: colors.green,
    borderRadius: '100%',
  },
  icon: {
    width: 30,
    height: 30,
    color: colors.white,
  },
  text: {
    color: colors.darkBlue,
    textAlign: 'center',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

const stepData = [
  {
    title: <p css={styles.text}>Centralized Credentialing</p>,
    icon: <SimpleLineIcon name="badge" size="Large" color={colors.white} />,
  },
  {
    title: <p css={styles.text}> Malpractice Coverage</p>,
    icon: <FolderSpecial style={{...styles.icon, width: 35, height: 35}}/>,
  },
  {
    title: <p css={styles.text}>Seamless Calendaring</p>,
    icon: <FaCalendar style={styles.icon}/>,
  },
]

const Step = ({ step, title, icon }) =>
  <div key={step} css={styles.item}>
    <div css={styles.iconHolder}>
      {icon}
    </div>
    {title}
  </div>

const Steps = () => {
  const stepElements = stepData.map((currentStep, index) => <Step {...currentStep} step={index + 1} />)
  return (
    <div css={styles.container}>
      {stepElements}
    </div>
  )
}

export default Steps


// WEBPACK FOOTER //
// ./src/components/hybrid/benefits.js